<template>
   <el-dialog
   title="预览"
   :width="800"
    :destroy-on-close ="true"
    :show-close="false"
    v-model="dialogVisible"
  >
    <video width="600" height="400" :src="src" controls autoplay></video>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="close()">关 闭</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>

import { downFile } from '@/libs/http';
export default {
  data() {
    return {
      src:'',
      dialogVisible: false,
    }
  },
  methods: {
    close() {
      this.dialogVisible = false;
      this.src = ''
    },
    show(item){
      this.dialogVisible = true
      const id = item.fileId
      downFile({id}).then((data)=>{
           if (!data.data) {
          alert('文件下载失败')
          return
        }
        if(data.headers['content-disposition']!=null){
          let fileName = decodeURIComponent(data.headers['content-disposition'].split('=')[1]);
        
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data.data], { type: 'application/octet-stream' }), fileName + '.mp4')
        } else {
          let url = window.URL.createObjectURL(new Blob([data.data], { type: 'application/octet-stream”' }))
          this.src = url
        }
        }
      })
    }
  },
}
</script>